import React from "react";
import { UISelectors } from "../../redux/selectors";
import { UrlUtils } from "../../utils";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { device } from "../../devices";

const HeaderRegulatoryTextWrapper = styled.div`
  flex-grow: 1;
`;

const RegulatoryTextContent = styled.div`
  color: #a1a1a1;
  width: 47.5rem;
  line-height: 1.4rem;
  z-index: 10;
  text-align: left;
  font-size: 1rem;
  letter-spacing: 0.7px;
  position: relative;
  white-space: break-spaces;

  @media ${device.mobileScreen} {
    padding: 0 9px;
    position: relative;
    width: 100%;
    height: auto;
    font-size: 9px;
    font-weight: normal;
    line-height: 1.1rem;
    text-align: center;
    text-indent: 0;
    color: #717171;
    clear: both;
  }

  @media ${device.wideScreen} {
    width: 39rem;
    font-size: 8px;
    letter-spacing: 0.36px;
    line-height: 1.1rem;
    :before {
      height: 3.3rem;
    }
  }

  @media ${device.desktopScreen} {
    :before {
      content: "";
      width: 1px;
      height: 4rem;
      background: #474747;
      position: absolute;
      top: -5px;
      left: -2rem;
    }
  }
`;

const RegulatoryTextLink = styled.a`
  color: #a1a1a1 !important;
  text-decoration: underline !important;
  @media ${device.mobileScreen} {
    color: #717171 !important;
  }
`;

const HeaderRegulatoryText = () => {
  const links = useSelector(UISelectors.links);
  return (
    <HeaderRegulatoryTextWrapper>
      <RegulatoryTextContent>
        Il gioco è vietato ai minori e può causare dipendenza patologica. Clicca
        per{" "}
        <RegulatoryTextLink
          href={UrlUtils.getNativeLink(
            links.headerRegulatoryTextProbabilitaVincita
          )}
          target="_blank"
        >
          Probabilità di vincita
        </RegulatoryTextLink>{" "}
        o per{" "}
        <RegulatoryTextLink
          href={UrlUtils.getNativeLink(
            links.headerRegulatoryTextQuotaFissaNote
          )}
          target="_blank"
        >
          maggiori informazioni
        </RegulatoryTextLink>{" "}
        .
      </RegulatoryTextContent>
    </HeaderRegulatoryTextWrapper>
  );
};

export default HeaderRegulatoryText;
